import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import content from 'prismic-translates/page-vip.json'
import Loader from 'src/components/Loader'
import Page from 'src/components/Page'
import VIPRewards from 'src/containers/VIPRewards'
import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import { isLoggedInSelector } from 'store/modules/user/selectors'

import LogInToAccess from '../LogInToAccess'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

export default function VIPLoyaltyRewards() {
  const isLoggedIn = useAppSelector(isLoggedInSelector)
  const isAppInitialized = useAppSelector(isAppInitializedSelector)

  if (!isAppInitialized) {
    return (
      <Page>
        <Loader />
      </Page>
    )
  }

  if (isLoggedIn) {
    return (
      <Page>
        <h4 className={`mt-typography-h4 ${classes.title}`}>{t('title')}</h4>
        <VIPRewards />
      </Page>
    )
  }

  return <LogInToAccess />
}
